var map = {
	"./4ed4b19af0c80b9652d9.jpg": "bvO8",
	"./838b4325c8a132ff6bb0.jpg": "RrBs",
	"./DongAnh.png": "v436",
	"./Levietnga.png": "Yn6n",
	"./ThangLong.png": "Jx4D",
	"./ThuongTin.png": "u+xk",
	"./background.jpg": "ycj+",
	"./bds.jpg": "Ahmw",
	"./bocongthuong.png": "VpPv",
	"./bua.svg": "talb",
	"./fdaf5a3571b28becd2a3.jpg": "3unS",
	"./hd.jpg": "3L7W",
	"./header_icon1.png": "sgaM",
	"./hoangminhduc.png": "sLr+",
	"./hoc.jpg": "/Sz+",
	"./hopbao.gif": "xrmb",
	"./kieuthilan.jpg": "hhjv",
	"./kq.png": "5frk",
	"./logo.jpg": "4GjL",
	"./logo.svg": "zxL1",
	"./luatdaugia.jpg": "ITvv",
	"./nghidinh.jpg": "nzyF",
	"./nguyenduchiet.png": "jtr5",
	"./nguyenngocyen.png": "hPY0",
	"./nguyenthanhhang.jpg": "nqDw",
	"./nguyenthinu.png": "uQxo",
	"./nh.jpg": "KLTb",
	"./oto.jpg": "0h13",
	"./phamthihoc.png": "kzEr",
	"./phiendaugiathuongtin.jpg": "x3sT",
	"./quanvanminh.png": "BOie",
	"./sep.jpg": "DK5l",
	"./ship.jpg": "S+k7",
	"./taothuminhnguyet.png": "2xcf",
	"./thongbao.jpg": "Mqky",
	"./thu truong B.jpg": "p11t",
	"./tranthitinh.jpg": "fDu+",
	"./tsc.jpg": "tSWH",
	"./tsk.jpg": "BNaA",
	"./vuvanhue.png": "encr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1